// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.online-shop-stock-table[data-v-52c8594b] .el-table__cell{\n   overflow: hidden;\n}\n.table-goods-info[data-v-52c8594b]{\n  padding-right: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
